import React from 'react';
import _ from 'lodash';

import {
  Box,
  IconButton,
  styled,
  Typography
} from '@mui/material';

import { BaseWidget } from 'modules/layer01';
import { CopyAll } from '@mui/icons-material';
import { referralUtil } from 'modules/layer00';



const UrlContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
  alignItems: 'center'
}));

const UrlCode = styled('code')(({ theme }) => ({
  backgroundColor: '#e6e6e6',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer'
}));

const ExampleCode = styled('code')(({ theme }) => ({
  color: theme.palette.warning.main
}));



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const referralLink = React.useMemo(
    () => referralUtil.genReferralLink({
      storeId: props.storeId,
      customerEmail: 'email@email.com',
      orderNumber: 'ABC_12345'
    }),
    [props.storeId]
  );

  const [isCopied, setIsCopied] = React.useState(false);



  async function handleClickUrl() {
    await window.navigator.clipboard.writeText(referralLink);
    setIsCopied(true);

    _.delay(() => {
      setIsCopied(false);
    }, 2000);
  }

  return (
    <BaseWidget.FC title="Referral">
      <Typography>
        The URL below is to be used as a method to refer a customer to their orders.
      </Typography>

      <Typography>
        It takes <ExampleCode>orderNumber</ExampleCode> and <ExampleCode>customerEmail</ExampleCode> search parameters.
      </Typography>

      <Typography>
        For example:
      </Typography>

      <ExampleCode>
        {referralLink}
      </ExampleCode>

      <UrlContainerBox>
        <UrlCode onClick={handleClickUrl}>
          {referralLink}
          <IconButton>
            <CopyAll />
          </IconButton>
        </UrlCode>

        {isCopied && (
          <Typography>
            Copied!
          </Typography>
        )}
      </UrlContainerBox>
    </BaseWidget.FC>
  );
};
